import { changeVariantQuantity } from '../slice/product.slice';

export const variantQuantityUpdatedEvent = changeVariantQuantity;
